__turbopack_context__.v({
  "container": "KeyPoints-module-scss-module__Jl0vAq__container",
  "darkWrapper": "KeyPoints-module-scss-module__Jl0vAq__darkWrapper",
  "lightBlueWrapper": "KeyPoints-module-scss-module__Jl0vAq__lightBlueWrapper",
});
